export const darkTheme = {
    bg:"linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #16213e 100%)",
    bgLight: "rgba(17, 17, 17, 0.3)",
    primary:"#ffffff",
    text_primary:"#ffffff",
    text_secondary:"#b4b4b4",
    card:"rgba(255, 255, 255, 0.05)",
    cardBorder:"rgba(255, 255, 255, 0.1)",
    card_light: 'rgba(255, 255, 255, 0.03)',
    button:"#ffffff",
    white:"#FFFFFF",
    black:"#000000",
    glass: "rgba(255, 255, 255, 0.08)",
    glassBorder: "rgba(255, 255, 255, 0.15)",
}

export const lightTheme = {
    bg:"#FFFFFF",
    bgLight: "#f0f0f0",
    primary:"#be1adb",
    text_primary:"#111111",
    text_secondary:"#48494a",
    card:"#FFFFFF",
    button:"#5c5b5b",
}
